import * as React from "react";
import { createDatabase } from "../../actions/createDatabase";
import { lang } from "../../lang";
import { Button } from "../../components/atoms/Button";
import { FlexHorizontal, FlexSpacer } from "../../components/atoms/Flex";
import { InputField } from "../../components/atoms/InputField";
import { Title } from "../../components/atoms/Text";
import { Popup } from "../../components/molecules/Popup";
import { catchEndpoint } from "../../catchEndpoint";

class CreateClient extends React.Component<{
    onClose: (ok?: boolean) => void;
}> {
    public state = {
        db: "",
        dbError: "",
        lock: false
    };
    public createDB = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (this.state.lock) {
            return;
        }
        if (this.state.db.match(/^[a-z]{3,8}$/)) {
            this.setState({ lock: true });
            createDatabase(this.state.db)
                .catch(catchEndpoint)
                .finally(() => {
                    this.props.onClose(true);
                });
        } else {
            this.setState({
                dbError: lang.dbNameError
            });
        }
    };
    public formChange = (text: string, name: string): void => {
        const state = this.state;
        state[name] = text;
        this.setState(state);
    };
    public onClose = (): void => {
        if (this.state.lock) {
            return;
        }
        this.props.onClose();
    };
    public render(): React.ReactElement {
        const { db, dbError } = this.state;
        return (
            <Popup onClose={this.onClose}>
                <Title className="title_create">{lang.addDatabase}</Title>
                <form onSubmit={this.createDB}>
                    <InputField
                        id="newdbname"
                        data-at_id="new_db_name"
                        name="db"
                        autoFocus
                        title={lang.databaseName}
                        type="text"
                        onChangeField={this.formChange}
                        value={db}
                        error={dbError}
                    />
                    <FlexHorizontal>
                        <FlexSpacer />
                        <Button
                            id="createuserbtn"
                            data-at_id="create_db_button"
                            loading={this.state.lock}
                            disabled={this.state.lock}
                            submit
                            right
                            title={lang.add}
                            style={{ flex: 1, marginBottom: "-5px" }}
                        />
                    </FlexHorizontal>
                </form>
            </Popup>
        );
    }
}

export { CreateClient };
